<template>
  <div class="main-buy-and-sell">
    <div class="buttons">

      <button @click="select = 'price'" class="solid-gray-btn" :class="{'gray-btn' : select === 'price'}">
        Market
      </button>

      <button @click="select = 'limit'" class="solid-gray-btn" :class="{'gray-btn' : select === 'limit'}">
        LimitOrder
      </button>

      <button @click="select = 'Stop-Limit'" class="solid-gray-btn" :class="{'gray-btn' : select === 'Stop-Limit'}">
        Stop-Limit
      </button>

      <button @click="select = 'OCO'" class="solid-gray-btn" :class="{'gray-btn' : select === 'OCO'}">
        OCO
      </button>

    </div>

    <div class="buy-and-sell">

      <!--      buy section -->
      <div class="box">

        <div class="value">
          <span>موجودی تومانی</span>
          <span class="number">123,548,789 TMN</span>
        </div>

        <!-- Market section -->
        <div v-if="select === 'price'" class="best-of-price-trade">
          <div class="right">
            <span class="trade-price">قیمت خرید</span>
            <span class="best-price">بهترین قیمت بازار</span>
          </div>
          <div class="left">
            <span class="price">{{ selectCoin[0].price }}</span>
            <inline-svg :src="require('../../../assets/coins/TOMAN.svg')"/>
          </div>
        </div>
        <custom-buy-input v-if="select === 'price'" :data="selectCoin" placeholder='حجم خرید'/>


        <!-- LimitOrder -->
        <div v-if="select === 'limit'" class="stop">
          <div class="right">
            <span class="trade-price">قیمت خرید</span>
            <span class="best-price">سفارش خرید در قیمت (stop)</span>
          </div>
          <div class="left">
            <inline-svg :src="require('../../../assets/coins/BTC.svg')"/>
          </div>
        </div>
        <custom-buy-input v-if="select === 'limit'" :data="selectCoin" placeholder='حجم خرید'/>


        <!--Stop-Limit-->
        <custom-buy-input v-if="select === 'Stop-Limit'" :data="selectCoin" placeholder='حد قیمت خرید'/>
        <custom-buy-input v-if="select === 'Stop-Limit'" :data="selectCoin" placeholder='سفارش خرید در قیمت'/>
        <custom-buy-input v-if="select === 'Stop-Limit'" :data="selectCoin" placeholder='حجم خرید'/>

        <!-- OCO-->
        <custom-buy-input v-if="select === 'OCO'" :data="selectCoin" placeholder='کف قیمت خرید'/>
        <custom-buy-input v-if="select === 'OCO'" :data="selectCoin" placeholder='سقف قیمت خرید'/>
        <custom-buy-input v-if="select === 'OCO'" :data="selectCoin" placeholder='سفارش خرید در قیمت'/>
        <custom-buy-input v-if="select === 'OCO'" :data="selectCoin" placeholder='حجم خرید'/>


        <!--range input type -->
        <div class="range">
          <custom-input-range @change="givamount"/>
        </div>
        <div class="text-rang">
          <span>کارمزد : 0.5%</span>
          <span>مقدار : 0.5%</span>
        </div>
        <!--        دریافتی شما -->
        <div class="resive">
          <span>دریافتی شما</span>

          <div class="input">
            <span class="resive-value number">{{ totalValue.toFixed(3) + ' ' + selectCoin[0].coin }}</span>
            <img :src="require('../../../assets/coins/' + selectCoin[0].coin+ '.svg')" alt=""/>
          </div>
        </div>
        <!--        buttons -->
        <button class="buyBtn">خرید</button>
      </div>

      <!--      sell section -->
      <div class="box">

        <div class="value">
          <span>موجودی ارزی</span>
          <span class="number">1 BTC</span>
        </div>

        <!-- Market section -->
        <div v-if="select === 'price'" class="best-of-price-trade">
          <div class="right">
            <span class="trade-price">قیمت خرید</span>
            <span class="best-price">بهترین قیمت بازار</span>
          </div>
          <div class="left">
            <span class="price">{{ selectCoin[0].price }}</span>
            <inline-svg :src="require('../../../assets/coins/TOMAN.svg')"/>
          </div>
        </div>
        <custom-buy-input v-if="select === 'price'" :data="selectCoin" placeholder='حجم خرید'/>

        <!-- LimitOrder -->
        <div v-if="select === 'limit'" class="stop">
          <div class="right">
            <span class="trade-price">قیمت فروش</span>
            <span class="best-price">سفارش فروش در قیمت (stop)</span>
          </div>
          <div class="left">
            <inline-svg :src="require('../../../assets/coins/BTC.svg')"/>
          </div>
        </div>
        <custom-buy-input v-if="select === 'limit'" :data="selectCoin" placeholder='حجم فروش'/>

        <!--Stop-Limit-->
        <custom-buy-input v-if="select === 'Stop-Limit'" :data="selectCoin" placeholder='حد فروش خرید'/>
        <custom-buy-input v-if="select === 'Stop-Limit'" :data="selectCoin" placeholder='سفارش فروش در قیمت'/>
        <custom-buy-input v-if="select === 'Stop-Limit'" :data="selectCoin" placeholder='حجم فروش'/>

        <!-- OCO-->
        <custom-buy-input v-if="select === 'OCO'" :data="selectCoin" placeholder='کف قیمت فروش'/>
        <custom-buy-input v-if="select === 'OCO'" :data="selectCoin" placeholder='سقف قیمت فروش'/>
        <custom-buy-input v-if="select === 'OCO'" :data="selectCoin" placeholder='سفارش فروش در قیمت'/>
        <custom-buy-input v-if="select === 'OCO'" :data="selectCoin" placeholder='حجم فروش'/>

        <!--range input type -->
        <div class="range">
          <custom-input-range @change="givamountsell "/>
        </div>
        <div class="text-rang">
          <span>کارمزد : 0.5%</span>
          <span>مقدار : 0.5%</span>
        </div>
        <!--        دریافتی شما -->
        <div class="resive">
          <span>دریافتی شما</span>

          <div class="input">
            <span class="resive-value number">{{ totalValuesell.toFixed(3) + ' ' + 'TMN' }}</span>
            <img src="../../../assets/coins/TOMAN.svg" alt="">
          </div>
        </div>
        <!--        buttons -->
        <button class="sellBtn">فروش</button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomBuyInput from "../../tools/custom-buy-input";
import CustomSellInput from "../../tools/custom-sell-input";
import CustomInputRange from "../../tools/custom-input-range";

export default {
  name: "buy-and-sell",
  components: {CustomInputRange, CustomSellInput, CustomBuyInput},
  props: ['data'],
  data() {
    return {
      select: 'price',
      focusebuy: false,
      focusesell: false,
      pricefromserver: 123548789,
      amount: 0,
      totalValue: 0,
      amountsell: 0,
      totalValuesell: 0,
      resiveValue: 0,
      selectCoin: [],
      coins: [
        {coin: 'BTC', price: 1255451, topPrice: 1451251, lowPrice: -1105565, changes: 0.6, value: 1234556},
        {coin: 'DOGE', price: 1455451, topPrice: 1545251, lowPrice: 17897565, changes: -0.8, value: 1274756},
        {coin: 'BNB', price: 17488451, topPrice: 145445251, lowPrice: -11056465, changes: 0.9, value: 15244556},
        {coin: 'ETH', price: 12452451, topPrice: 14788251, lowPrice: 74505565, changes: -0.3, value: 15457556},
        {coin: 'BCH', price: 1454451, topPrice: 5451251, lowPrice: -1454565, changes: 0.2, value: 12785756},
        {coin: 'XLM', price: 14555451, topPrice: 1455251, lowPrice: 5455565, changes: -0.1, value: 5454556},
        {coin: 'XRP', price: 4545451, topPrice: 5451251, lowPrice: -17485565, changes: 0.4, value: 14545556},
        {coin: 'TRX', price: 1545451, topPrice: 1545451, lowPrice: 1577565, changes: -0.5, value: 85774556},
      ]
    }
  },

  methods: {
    givamount(value) {
      console.log('givamount')
      this.amount = value
      this.totalValue = this.amount * this.pricefromserver
    },

    givamountsell(value) {
      console.log('givamountsell')
      this.amountsell = value
      this.totalValuesell = this.amountsell * this.pricefromserver
    },

    getmarket() {
      for (let i = 0; i < this.coins.length; i++) {
        if (this.data === this.coins[i].coin) {
          this.selectCoin.push(this.coins[i]);
        }
      }
    }
  },

  created() {
    this.getmarket()
  }
}
</script>

<style lang="scss" scoped>
//public class
.gray-btn {
  background: rgba(215, 200, 200, 0.12) !important;
  border-radius: 4px !important;
  color: rgba(17, 153, 250, 1) !important;
  cursor: pointer !important;
  font-size: clamp(10px, 2vw, 12px) !important;
  height: auto;
  width: auto;
}

.buyBtn {
  width: 100%;
  height: 36px;
  background: #04B3A2;
  border-radius: 4px;
  color: #FFFFFF;
  cursor: pointer;
  position: absolute;
  bottom: 0;

  &:hover {
    background: linear-gradient(180deg, #03DAC5 0%, rgba(140, 166, 142, 0) 425%);
  }
}

.sellBtn {
  width: 100%;
  height: 36px;
  background: #D94F68;
  border-radius: 4px;
  color: #FFFFFF;
  cursor: pointer;
  position: absolute;
  bottom: 0;

  &:hover {
    background: linear-gradient(180deg, #D94F68 0%, rgba(255, 60, 95, 0) 355.56%);
  }
}

.main-buy-and-sell {
  display: flex;
  flex-direction: column;
  gap: 8px;
  direction: rtl;

  .buttons {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    button {
      width: 150px;
      height: 25px;
    }
  }

  .range {
    display: flex;
    width: 100%;
    height: 20px;
    flex-direction: column;
    gap: 10px;
    position: absolute;
    bottom: 130px;

  }

  .text-rang {
    display: flex;
    width: 100%;
    justify-content: space-between;
    font-size: 10px;
    color: rgba(215, 200, 200, 1);
    position: absolute;
    bottom: 100px;
  }

  .resive {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 10px;
    border: 1px solid #8C8585;
    box-sizing: border-box;
    border-radius: 4px;
    align-items: center;
    width: 100%;
    height: 36px;
    position: absolute;
    bottom: 50px;

    span {
      color: rgba(140, 133, 133, 1);
      font-size: 12px;
    }

    .input {
      display: flex;
      align-items: center;

      .resive-value {
        font-size: 14px;
        color: #FFFFFF;
        margin-left: 10px;
      }
    }
  }

  .buy-and-sell {
    display: flex;
    flex-direction: row;
    background: linear-gradient(180deg, rgba(140, 133, 133, 0.12) 0%, rgba(215, 200, 200, 0.0408) 100%);
    border-radius: 4px;
    min-height: 370px;
    gap: 20px;
    padding: 14px;
    flex-wrap: wrap;

    .box {
      display: flex;
      flex-grow: 1;
      flex-basis: 100px;
      flex-wrap: wrap;
      flex-direction: column;
      gap: 16px;
      position: relative;

      .value {
        font-size: 10px;
        color: rgba(215, 200, 200, 1);
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 20px;
        direction: rtl;
      }

      .best-of-price-trade {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 36px;
        background: rgba(215, 200, 200, 0.12);
        border: 0.75px solid #8C8585;
        border-radius: 4px;
        margin-top: -10px;

        svg {
          margin-left: 6px;
        }

        .right {
          display: flex;
          flex-direction: column;
          text-align: right;
          flex-grow: 1;
          justify-content: start;
          margin-right: 6px;

          .trade-price {
            font-size: 10px;
            color: #1199FA;
          }

          .best-price {
            font-size: 11px;
            color: #FFFFFF;
          }
        }

        .left {
          display: flex;
          flex-grow: 1;
          align-items: center;
          justify-content: end;
          gap: 5px;

          .price {
            font-size: 12px;
            font-weight: bold;
          }
        }
      }

      .stop{
        @extend .best-of-price-trade;
        background: none !important;
      }


    }
  }
}

@media (max-width: 992px) {
  .buttons {
    gap: 10px !important;
  }
  .buttons button {
    width: auto !important;
  }

  .change-type {
    justify-content: space-between !important;
  }
}

@media (max-width: 500px) {
  .buy-and-sell {
    flex-direction: column !important;
    gap: 40px;
    min-height: 770px !important;
  }

  .box {
    gap: 10px;
  }

  .text-rang {
    margin-top: 10px;
  }
}

@media (max-width: 380px) {
  .main-trade {
    padding: 5px !important;
  }
}
</style>